import { RfiDto, RfiRequestDto } from 'src/api/FiretrolApiClient';
import { rfiApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleMutations } from 'src/api/queries/workflowModules/createModuleMutations';
import { queryKeys } from 'src/api/queries/queryKeys';

const mutations = createModuleMutations<RfiDto, RfiRequestDto>({
  label: 'RFI',
  saveOp: 'rfi.save',
  detailKey: queryKeys.rfis.detail,
  getId: (dto) => dto.id,
  save: (jobId, request) => rfiApiClient.createOrUpdateRfi(jobId, request),
  attachFromDocument: (jobId, documentId) =>
    rfiApiClient.attachFromDocument(jobId, { documentId }),
  rotateExternalAccess: (jobId, id) =>
    rfiApiClient.rotateExternalAccess(jobId, id),
  uploadTempFile: (file, category) =>
    rfiApiClient.uploadTempFile({ data: file, fileName: file.name }, category),
  generatePdf: (jobId, id) => rfiApiClient.generateRfiPdf(jobId, id),
  previewPdf: (jobId, id) => rfiApiClient.previewRfiPdf(jobId, id),
  logPdf: (jobId, statuses, contactId) =>
    rfiApiClient.getRfiLogPdf(jobId, statuses, contactId),
});

export const useSaveRfi = mutations.useSave;
export const useAttachRfiDocument = mutations.useAttachFromDocument;
export const useRotateRfiExternalAccess = mutations.useRotateExternalAccess;
export const useGenerateRfiPdf = mutations.useGeneratePdf;
export const usePreviewRfiPdf = mutations.usePreviewPdf;
export const useRfiLogPdf = mutations.useLogPdf;
